import { inv, multiply, subtract } from "mathjs"
import globalKMatrix from "./globalKMatrix"
import geometricProps from "./geometricProps"
import rotationMatrix from "./rotationMatrix"
import localKMatrix from "./localKMatrix"
import distributedToNodalForces from '../functions/distributedToNodalForces'

var EIS = []
var dLocal = []
var localForce = []


function solver(nNodes, nBar, barNodes, restrictedDisplacementVector, forceVector, barPropsArray, analysisType, distributedMagnitudeX, distributedMagnitudeY) {

    var isSecondOrder = analysisType
    
    //matriz de rigidez global
    const kGlobal = globalKMatrix(barNodes, nNodes, barPropsArray, nBar, restrictedDisplacementVector, forceVector, isSecondOrder, distributedMagnitudeX, distributedMagnitudeY).kGlobal

    //Penalty
    var forceVectorPenalty = [...forceVector]
    var kGlobalPenalty = [...kGlobal]
    for (let i = 0; i < 3*nNodes; i++){

        if(restrictedDisplacementVector[i] === 1){
            //kGlobal[i] = new Array(3*nNodes).fill(0)
            for (let j = 0; j < 3*nNodes; j++){
                kGlobalPenalty[i][j] = 0
            }
            forceVectorPenalty[i] = 0
            for (let k = 0; k < 3*nNodes; k++){
                kGlobalPenalty[k][i] = 0
            }
            kGlobalPenalty[i][i] = 1
        }
    }
    

    //Calculo dos deslocamentos através da equação {D} = [K]^-1 * {Fe}:
    var kGlobalInv = inv(kGlobalPenalty)
    var D = multiply(kGlobalInv, forceVectorPenalty)
    //D = D*(-1)


    const Global = globalKMatrix(barNodes, nNodes, barPropsArray, nBar, restrictedDisplacementVector, forceVector, isSecondOrder, distributedMagnitudeX, distributedMagnitudeY)
    const kGlobal2 = Global.kGlobal

    //Calculo dos EIS
    for(let i = 0; i < nBar; i++){
        for(let j = 0; j < 3; j++){
            var node1 = barNodes[i][2]
            var node2 = barNodes[i][5]

            dLocal[j] = D[3*node1+j]
            dLocal[j+3] = D[3*node2+j]

            localForce[j] = forceVector[3*node1+j]
            localForce[j+3] = forceVector[3*node2+j]
        }

        var geometry = geometricProps(barNodes, i)
        var beta = rotationMatrix(geometry.sn, geometry.cs)
        var dLocalRotated = multiply(beta, dLocal)
        var EA = barPropsArray[i][0] * barPropsArray[i][2]
        var EI = barPropsArray[i][0] * barPropsArray[i][1]
        var rLocal
        if(isSecondOrder){
            rLocal = Global.kglocal[i]
            console.log("Estou aqui!")
        }
        else{
            rLocal = localKMatrix(geometry.L, EA, EI)
        }
        EIS[i] = new Array(0)
        for (let j = 0; j < 6; j++){
            EIS[i][j] = 0
        }

        EIS[i] = multiply(rLocal, dLocalRotated)

        if(distributedMagnitudeX[i] !== 0 || distributedMagnitudeY[i] !== 0){
            localForce = distributedToNodalForces(distributedMagnitudeX[i], distributedMagnitudeY[i], barNodes, i).array

            //EIS[i] = add(EIS[i],localForce)
            
            for(let j = 0; j < 6; j++){
                EIS[i][j] = EIS[i][j] - localForce[j]
            }
        }

        //EIS[i] = add(EIS[i],localForce)
    }

    //Calculo das Reações:
    var R = multiply(kGlobal2, D)
    R = subtract(R, forceVector)

    return {R, EIS, D}
}

export default solver